import { useMemo } from 'react';
import { thumbHashToDataURL } from 'thumbhash';

export function useThumbHash(thumbHash?: string, thumbnail?: string): string | undefined {
  return useMemo(() => {
    if (thumbHash) {
      try {
        return thumbHashToDataURL(new Uint8Array(Buffer.from(thumbHash, 'base64')));
      } catch {
        return thumbnail;
      }
    }
    return thumbnail;
  }, [thumbHash, thumbnail]);
}
